import React, { Fragment } from 'react'
import estilos from './InstalacionesComponent.module.css'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import ModalHistorialCambiosComponent from './ModalHistorialCambiosComponent';

function InstalacionesComponent(props) {

    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState(props?.data?.informaciongeneralinstalacioncliente?.informaciongeneralinstalacionclientehistorial);
    const handleModalHistorial = () => {
        setDataHistorial(props?.data?.informaciongeneralinstalacioncliente?.informaciongeneralinstalacionclientehistorial)
        setOpenModalHistorial(true)
    }

    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });


    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                <div className={`${estilos.masterInfo}`}>
                    <div className={`${estilos.header}`} style={props?.data.isbaja ? { background: '#DC3545' } : { background: '#8ABE3E' }}>
                        <h4>{props?.data?.tipoanexo.descripcion.toUpperCase()}</h4>
                        <h5 style={{ marginTop: '2%' }}><b>Alias: </b>{(props?.data?.informaciongeneralinstalacioncliente.alias).toUpperCase()}</h5>
                    </div>
                    <div style={{ margin: 0, padding: 0 }}>
                        {props?.data?.isbaja == false &&
                            <div style={{ display: 'flex', justifyContent: 'end', marginTop: '-3%', paddingRight: '2%' }} >
                                <Tooltip title="Ver historial de cambios">
                                    <IconButton size="large" sx={{ p: 1 }} onClick={() => { handleModalHistorial() }}>
                                        <HistoryRoundedIcon fontSize="inherit" sx={{ color: '#2B2B2B' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                        <h6 style={{ marginTop: 0, marginLeft: '4%', textAlign: 'left' }} ><b>Ubicación:</b></h6>
                        <p style={{ margin: '4%', marginTop: 0, textAlign: 'justify' }}>{props?.data?.informaciongeneralinstalacioncliente.calle + ', ' + props?.data?.informaciongeneralinstalacioncliente.numerointerior + ', ' +
                            props?.data?.informaciongeneralinstalacioncliente.numeroexterior + ', ' + props?.data?.informaciongeneralinstalacioncliente.colonia + ', ' +
                            props?.data?.informaciongeneralinstalacioncliente.codigopostal + ', ' + props?.data?.informaciongeneralinstalacioncliente.localidad + ', ' +
                            props?.data?.informaciongeneralinstalacioncliente.municipio + ', ' + props?.data?.informaciongeneralinstalacioncliente.estado}</p>
                        {props?.data?.informaciongeneralinstalacioncliente?.responsablesdeinstalacioncliente?.length > 0 &&
                            <h6 style={{ textAlign: 'left', marginLeft: '4%' }}><b>Responsables de instalación:</b></h6>
                        }
                        {props?.data?.informaciongeneralinstalacioncliente?.responsablesdeinstalacioncliente?.map(responsable =>
                            <div className='row mt-3' style={{ width: '95%', margin: 'auto' }} >
                                <div className='col-12 col-md-5' style={{ wordWrap: 'break-word', textAlign: 'left' }} > {responsable.nombreresponsable.toUpperCase()} </div>
                                <div className='col-12 col-md-2' style={{ wordWrap: 'break-word', textAlign: 'left' }} > {responsable.telefono} </div>
                                <div className='col-12 col-md-5 pe-0' style={{ wordWrap: 'break-word', textAlign: 'left' }} > {responsable.correoelectronico} </div>
                            </div>
                        )}
                    </div>
                </div>
            </ThemeProvider>
            {openModalHistorial && <ModalHistorialCambiosComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} apartado={props?.data?.tipoanexo?.descripcion} />}
        </Fragment >
    )
}

export default InstalacionesComponent